import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { getSidebarCustomize, useCustomControl } from "@devowl-wp/customize";
import { RootStore } from "../../../store/stores.js";
import { __ } from "../../../utils/i18n.js";
/**
 * This control simply copies the decision option and provides the
 * exact same choices. This control does not hold any value!
 */ const DecisionButtonTypeSelectControl = ({ decision })=>{
    const { backboneView } = useCustomControl();
    // Obtain value and select choices
    const customize = getSidebarCustomize();
    const settingId = RootStore.get.optionStore.others.customizeIdsBanner.settings.decision[decision];
    const setting = customize(settingId);
    const value = setting.get();
    const options = {
        button: __("Button"),
        link: __("Link"),
        hide: __("Hide")
    };
    // Listen for changes and rerender this control
    let skipChange = false;
    useEffect(()=>setting.bind("change", ()=>!skipChange && backboneView.renderContent()), []);
    // Change the setting of the duplicated control
    const handleChange = useCallback((e)=>{
        skipChange = true;
        setting.set(e.target.value);
        skipChange = false;
        backboneView.renderContent();
    }, [
        setting
    ]);
    return /*#__PURE__*/ _jsx("select", {
        value: value,
        onChange: handleChange,
        children: Object.keys(options).map((key)=>/*#__PURE__*/ _jsx("option", {
                value: key,
                children: options[key]
            }, key))
    });
};
export { DecisionButtonTypeSelectControl };
